import { Fragment, useEffect, useRef, useState, useContext } from "react";
import { AppContext } from "../context";
import {
  addImageToList,
  getConstraint,
  getAspectRatioClientList,
  getWebpImageFormat,
  getImgQualityFactor,
  setCameraOpenFlag,
  getCameraOpenFlag,
  getNewConfirmBtn
} from "../context/utils";
import cameraImg from "../img/camera.png";
import Rotate from "./Rotate";
import { startVideoPlayback } from "../utils_new/videoPlayback";

let captured = 0;
let images = [];
let imagesUploaded = false;
let imgUrl = null;

const land = () => window.innerWidth > window.innerHeight * 1.2;

const CustomHiibModule = () => {
  const {
    inspectionId,
    clientId,
    stepCovered,
    setStepCovered,
    condition,
    config,
    currentBlock,
    setCurrentPage,
    setCondition,
    setScreen,
    mandatory,
    setMandatory,
    isLandscape,
    setLandscape,
    hiibCustomValue,
    isIOS
  } = useContext(AppContext);
  const videoRef = useRef();
  const canvasRef = useRef();
  const captureBtn = useRef();
  const screen3 = useRef();
  const imgRef = useRef();
  const reelsRef = useRef();
  const downListRef = useRef();
  const divImgRef = useRef();
  const reelMessage = useRef();
  const modalRef = useRef();
  const modalImg = useRef();
  const displayPopUp = useRef();
  const displayPopUpInstruction = useRef();
  const resizeDebounceRef = useRef(null);
  const [capturedImages, setCapturedImages] = useState([]);

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text))
      return config["language"][text];
    else return text;
  };

  const startCamera = () => {
    navigator.mediaDevices
      .getUserMedia(getConstraint(config, clientId))
      .then((stream) => {
        if (window.stream) {
          window.stream.getTracks().forEach((track) => track.stop());
          window.stream = null;
        }
        window.stream = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          startVideoPlayback(videoRef.current, config);
          if (captureBtn.current) captureBtn.current.style.display = "block";
          if (hiibCustomValue && displayPopUpInstruction.current) {
            displayPopUpInstruction.current.style.display = "flex";
          } else if (displayPopUpInstruction.current) {
            displayPopUpInstruction.current.style.display = "none";
          }
          setCameraOpenFlag(true);
        }
      })
      .catch((err) => {
        // console.error(err);
      });
  };

  const pushImgToList = (imgData) => {
    if (downListRef.current) downListRef.current.style.display = "flex";
    if (imgRef.current) imgRef.current.style.display = "none";
    const src = imgData ? imgData : imgUrl;
    setCapturedImages((prev) => [...prev, src]);
  };

  const captureImg = () => {
    if (capturedImages.length < 15) {
      const cnv = canvasRef.current;
      const vw = videoRef.current;
      cnv.width = vw.videoWidth;
      cnv.height = vw.videoHeight;
      cnv.getContext("2d").drawImage(vw, 0, 0);
      const imgData = getWebpImageFormat() && !isIOS
        ? cnv.toDataURL("image/webp", getImgQualityFactor())
        : cnv.toDataURL("image/jpeg")
      imgUrl = imgData; // Set the image URL for the captured image
      if (Object.keys(currentBlock).includes("showImgConfirmOption") && currentBlock["showImgConfirmOption"]) {
        downListRef.current.style.display = "none";
        divImgRef.current.src = imgData;
        imgRef.current.style.display = "block";
      }
      else pushImgToList(imgData);
    } else {
      displayPopUp.current.style.display = "flex";
    }
  };

  const showModal = (index) => {
    if (index !== undefined && capturedImages[index]) {
      modalImg.current.src = capturedImages[index];
      modalRef.current.style.display = "block";
    }
  };

  const hideModal = () => {
    modalRef.current.style.display = "none";
  };

  const handleNext = () => {
    if (window.stream) {
      window.stream.getTracks().forEach((track) => track.stop());
      window.stream = null;
    }
    setCameraOpenFlag(false);
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    imagesUploaded === false &&
      capturedImages.forEach((data) => {
        addImageToList({
          name: `${currentBlock["tag"]}.jpg`,
          imgData: data,
          tag: currentBlock["tag"],
          web_region: null,
          angle: null,
          region: region,
          env: 1,
          videoData: null,
          dialStatus: null,
        });
      });
    if (currentBlock["mandatory"]) {
      let temp1 = mandatory;
      temp1[currentBlock["id"]] = "completed";
      setMandatory(temp1);
    }
    let temp = condition;
    temp[currentBlock["id"]] = "completed";
    setCondition(temp);
    setScreen("menu");
  };

  useEffect(() => {
    setLandscape(land());
  }, []);

  useEffect(() => {
    const checkOrientation = () => {
      const isL = land();
      setLandscape(isL);
      if (!isL) {
        if (window.stream) {
          window.stream.getTracks().forEach((t) => t.stop());
          window.stream = null;
        }
        setCameraOpenFlag(false);
      } else {
        if (!getCameraOpenFlag()) {
          const restartDelay = isIOS ? 300 : 100;
          setTimeout(() => startCamera(), restartDelay);
        } else if (videoRef.current && window.stream) {
          videoRef.current.srcObject = window.stream;
          startVideoPlayback(videoRef.current, config);
        }
      }
    };

    const handleResize = () => {
      const processElement = document.querySelector(".hiib_size");
      if (processElement) {
        processElement.style.width = "100vw";
        processElement.style.height = `${window.innerHeight}px`;
      }
      if (isIOS) {
        if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
        resizeDebounceRef.current = setTimeout(checkOrientation, 200);
      } else {
        checkOrientation();
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
    };
  }, []);

  useEffect(() => {
    if (reelsRef.current && capturedImages.length > 0) {
      setTimeout(() => {
        if (reelsRef.current) {
          reelsRef.current.scrollLeft = reelsRef.current.scrollWidth;
        }
      }, 50);
    }
  }, [capturedImages.length, isLandscape]);

  useEffect(() => {
    imagesUploaded = false;
    imgUrl = null;
    if (land()) {
      startCamera();
    }
    return () => {
      imagesUploaded = false;
      imgUrl = null;
      if (window.stream) {
        window.stream.getTracks().forEach((track) => track.stop());
        window.stream = null;
      }
      setCameraOpenFlag(false);
    };
  }, []);

  return (
    <Fragment>
      {!isLandscape ? (
        <Rotate />
      ) : (
        <div
          className="hiib_size"
          style={{
            position: "relative",
            width: "100vw",
            height: "100dvh",
            overflow: "hidden",
          }}
          ref={screen3}
        >
          <canvas
            ref={canvasRef}
            id="ios-canvas"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></canvas>
          <video
            ref={videoRef}
            id="videoWindow"
            autoPlay
            playsInline
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : { width: "100vw", height: "100vh", objectFit: "cover" }
            }
          ></video>
          <div
            ref={captureBtn}
            style={{
              backgroundImage: `url(${cameraImg})`,
              backgroundSize: "37px 37px",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              backgroundPosition: "center",
            }}
            onClick={captureImg}
            id="btn-vin-start"
          ></div>
          <div
            id="vin-image"
            style={
              getAspectRatioClientList(clientId, config)
                ? { backgroundColor: "black", objectFit: "contain" }
                : {}
            }
            ref={imgRef}
          >
            {/* <p ref={pTagRef} className="pTag"></p> */}
            <img
              ref={divImgRef}
              style={
                getAspectRatioClientList(clientId, config)
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            />
            <div>
              {
                getNewConfirmBtn() ? (
                  <>
                    {/* <div id="modalNameCont" style={{ position: "absolute", top: "10%", left: "35%", fontSize: "16px" }}>
                      <p id="modalNameText">{currentSubBlock + " (" + getTranslateText("Preview") + ")"}</p>
                    </div> */}
                    <button
                      className="new-retake-btn"
                      style={{ backgroundColor: config["colors"]["crossBtn"] ? config["colors"]["crossBtn"] : "#FF8C00" }}
                      onClick={() => {
                        if (imgRef.current) imgRef.current.style.display = "none";
                        downListRef.current.style.display = "flex";
                      }}
                    >
                      <i className="fas fa-undo"></i>
                      {getTranslateText("Recapture")}
                    </button>
                    <button
                      className="new-next-btn"
                      style={{ backgroundColor: config["colors"]["btn"] }}
                      onClick={() => pushImgToList()}
                    >
                      <i className="fas fa-check"></i>
                      {getTranslateText("Done")}
                    </button>
                  </>
                ) : (
                  <>
                    <i
                      className="fas fa-times fa-2x vin-btn-retake"
                      onClick={() => {
                        if (imgRef.current) imgRef.current.style.display = "none";
                        downListRef.current.style.display = "flex";
                      }}
                    ></i>
                    <i
                      className="fas fa-check fa-2x vin-btn-next"
                      onClick={() => pushImgToList()}
                    ></i>
                  </>
                )
              }
            </div>
          </div>
          <div
            className="reel-container1"
            ref={downListRef}
          >
            <div ref={reelsRef} className="reels1">
              {capturedImages.map((src, index) => (
                <div
                  key={index}
                  className="reel-img-wrapper"
                  onClick={() => showModal(index)}
                >
                  <img src={src} alt={`captured-${index + 1}`} />
                  <span className="reel-img-number">{index + 1}</span>
                </div>
              ))}
            </div>
            <div className="form-btn" style={{ flexShrink: 0 }}>
              <button
                disabled={capturedImages.length === 0}
                style={{
                  backgroundColor: config["colors"]["btn"],
                  height: "40px",
                  margin: "0px",
                  width: "100%",
                  padding: "0 15px",
                  whiteSpace: "nowrap",
                  opacity: capturedImages.length === 0 ? "0.3" : "1"
                }}
                onClick={handleNext}
              >
                {getTranslateText("Continue")}
              </button>
            </div>
          </div>
          <div
            ref={modalRef}
            id="vin-image"
            style={
              getAspectRatioClientList(clientId, config)
                ? { backgroundColor: "black", objectFit: "contain" }
                : {}
            }
          >
            <div onClick={hideModal} className="close1">
              X
            </div>
            <img
              ref={modalImg}
              style={
                getAspectRatioClientList(clientId, config)
                  ? { objectFit: "contain" }
                  : {}
              }
              alt=""
            />
          </div>
          <div
            ref={displayPopUp}
            style={{ width: "100vw", height: "100vh" }}
            className="customPopup"
          >
            <div
              className="customPopupdiv"
              style={{
                width: "50vw",
                height: "50vh",
              }}
            >
              <p>{["dekre_nl_prod", "dekra_nl_uat"].includes(clientId) ? "Er werden 14 foto's gemaakt." : "14 images were captured"}</p>
              <div className="form-btn" style={{ width: "20%" }}>
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    width: "20%",
                    height: "40px",
                    margin: "0px",
                    width: "100%",
                  }}
                  onClick={handleNext}
                >
                  {getTranslateText("Continue")}
                </button>
              </div>
            </div>
          </div>
          <div
            ref={displayPopUpInstruction}
            style={{ width: "100vw", height: "100vh" }}
            className="customPopup"
          >
            <div
              className="customPopupdiv"
              style={{
                width: "50vw",
                height: "50vh",
              }}
            >
              <h4>Instructions</h4>
              <p>{hiibCustomValue}</p>
              <div className="form-btn" style={{ width: "20%" }}>
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    width: "20%",
                    height: "40px",
                    margin: "0px",
                    width: "100%",
                  }}
                  onClick={() => {
                    displayPopUpInstruction.current.style.display = "none";
                  }}
                >
                  {getTranslateText("Continue")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CustomHiibModule;
